import styles from './styles/Button.module.css';
export const SIZE_CLASS_MAP = {
    big: styles.Big,
    medium: styles.Medium,
    small: styles.Small,
};
export const KIND_STATE_CLASS_MAP = {
    primary: {
        disabled: styles.KindPrimaryDisabled,
        enabled: styles.KindPrimaryEnabled,
        loading: styles.KindPrimaryLoading,
    },
    secondary: {
        disabled: styles.KindSecondaryDisabled,
        enabled: styles.KindSecondaryEnabled,
        loading: styles.KindSecondaryLoading,
    },
    danger: {
        disabled: styles.KindDangerDisabled,
        enabled: styles.KindDangerEnabled,
        loading: styles.KindDangerLoading,
    },
    ghost: {
        disabled: styles.KindGhostDisabled,
        enabled: styles.KindGhostEnabled,
        loading: styles.KindGhostLoading,
    },
    'ghost-danger': {
        disabled: styles.KindGhostDangerDisabled,
        enabled: styles.KindGhostDangerEnabled,
        loading: styles.KindGhostDangerLoading,
    },
    link: {
        disabled: styles.KindLinkDisabled,
        enabled: styles.KindLinkEnabled,
        loading: styles.KindLinkLoading,
    },
};
export const LINE_HEIGHT_CLASS_MAP = {
    big: styles.LineHeightBig,
    medium: styles.LineHeightMedium,
    small: styles.LineHeightSmall,
};
export const ICON_SIZE_MAPPER = {
    big: 'middle',
    medium: 'small',
    small: 'xsmall',
};
